import type {
  AbstractControl,
  ValidationErrors,
  ValidatorFn,
} from '@angular/forms';

export const organisationValidator: ValidatorFn = (
  control: AbstractControl,
): ValidationErrors | null => {
  if (!control.value) {
    return {
      organisation: {
        valid: false,
      },
    };
  }

  const { businessAreas, divisions, hubs, localDivisions } = control.value;

  if (
    businessAreas?.length ||
    divisions?.length ||
    hubs?.length ||
    localDivisions?.length
  ) {
    return null;
  }

  return {
    organisation: {
      valid: false,
    },
  };
};
